import React, { useState } from 'react';
import api from '../api';
import { useNotification } from '../context/NotificationContext';
import './CharacterClassSelector.css';

const classes = [
  {
    id: 'tecno_mago',
    title: 'Tecno-Mago',
    description: 'Manipulador de flujos de información.',
    icon: '🔮'
  },
  {
    id: 'arquitecto_red',
    title: 'Arquitecto de Red',
    description: 'Defensa digital y escudos.',
    icon: '🛡️'
  },
  {
    id: 'cazador_datos',
    title: 'Cazador de Datos',
    description: 'Infiltración y extracción.',
    icon: '🕵️'
  }
];

export default function CharacterClassSelector({ currentClass, onSelect }) {
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();

  const handleSelect = async (classId) => {
    if (loading) return;
    setLoading(true);
    try {
      await api.put('/users/character-class', { characterClass: classId });
      addNotification('Clase de personaje actualizada con éxito.', 'success');
      if (onSelect) {
        onSelect(classId);
      }
    } catch (err) {
      console.error('Error updating character class:', err);
      addNotification(err.response?.data?.error || 'Error al actualizar la clase.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="character-class-selector">
      <div className="class-cards-container">
        {classes.map((cls) => {
          const isSelected = cls.id === currentClass;
          return (
            <div
              key={cls.id}
              className={`class-card ${isSelected ? 'selected' : ''} ${loading ? 'disabled' : ''}`}
              onClick={() => handleSelect(cls.id)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleSelect(cls.id);
              }}
            >
              <div className="class-icon">{cls.icon}</div>
              <h4 className="class-title">{cls.title}</h4>
              <p className="class-description">{cls.description}</p>
              {isSelected && <div className="class-selected-badge">Seleccionado</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
